module.exports = __webpack_public_path__ + "static/media/things-to-know-about-startup-business - Copy.f7f6d29a.md";